import React, { useState } from 'react'
import { Button, Modal, Table, notification } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { sortedArray, sortedArrayCap } from '../../../config/helperFunctions'

const AddPlayerToTrade = ({ data, teamName, selected, setSelected }) => {
  const [open, setOpen] = useState(false)
  const showModal = () => {
    // if (data?.length > 0) {
    setOpen(true)
    // } else {
    //   notification.error({
    //     message: 'Please select team first',
    //     duration: 3,
    //   })
    // }
  }
  const closeModal = () => setOpen(false)

  const columns = [
    {
      title: 'POSITION',
      dataIndex: 'Position',
      key: 'Position',
      width: 110,
      render: (_, obj) => <p>{obj?.player_id?.Position}</p>,
    },
    {
      title: 'NAME',
      dataIndex: 'Name',
      key: 'Name',
      render: (_, obj) => <p>{obj?.player_id?.Name}</p>,
    },
    {
      title: 'PLAYER CAP',
      dataIndex: 'PlayerCap',
      key: 'PlayerCap',
      render: (_, obj) => <p>${obj?.player_id?.PlayerCap?.toLocaleString()}</p>,
      width: 155,
    },
    {
      title: ' ',
      dataIndex: '_id',
      key: '_id',
      width: 150,
      render: (_, obj) => {
        const isDisable = selected?.find((x) =>
          x?.player_id?._id === obj?.player_id?._id ? true : false,
        )
        return (
          <Button
            disabled={isDisable}
            type='primary'
            onClick={() => {
              setSelected((pre) => [...pre, obj])
              closeModal()
            }}
          >
            {isDisable ? 'Selected' : 'Select'}
          </Button>
        )
      },
    },
  ]

  return (
    <>
      {/* <Button type='primary' style={{ float: 'right' }} onClick={showModal}>
        Add Another Team
      </Button> */}
      <p onClick={showModal} style={{ cursor: 'pointer' }}>
        <PlusOutlined /> Add Player
      </p>
      <Modal
        centered
        open={open}
        onCancel={closeModal}
        footer={null}
        closeIcon={false}
        className='player_interface_modals'
        closable={false}
      >
        <div className='close_modal_button' onClick={closeModal}>
          x
        </div>
        <div className='modal_body'>
          <h1 className='modal_header_heading main_heading'>
            ADD PLAYER TO TRADE {teamName && `(${teamName})`}
          </h1>

          <div className='center_content trade_player'>
            <h1 className='modal_header_heading'>BUILD YOUR DEAL</h1>
            <p
              style={{ textTransform: 'uppercase' }}
            >{`SELECT THE PLAYER YOU WISH TO BE A PART OF THIS TRADE!`}</p>
          </div>

          <h1 className='modal_header_heading'>TEAM ROSTER</h1>

          <div className='modal_roster_table_box'>
            <Table
              // dataSource={sortedArray(data)}
              dataSource={sortedArrayCap(data)}
              columns={columns}
              footer={false}
              pagination={false}
              scroll={{ y: 300, x: 750 }}
              rowKey={'_id'}
            />
            ;
          </div>
        </div>
      </Modal>
    </>
  )
}

export default AddPlayerToTrade
